var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.values.text)?_c('div',{staticClass:"paragraph",domProps:{"innerHTML":_vm._s(_vm.values.text)}}):(!_vm.values.text)?_c('div',{staticClass:"paragraph"},[_c('p',[_vm._v(_vm._s(_vm.l("Enter text...")))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }